import { Injectable, inject } from '@angular/core';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { SessionLifecycleService } from '@shared/services/session-lifecycle';
import { LogService } from './log.service';

@Injectable({ providedIn: 'root' })
export class FingerprintService {
  private readonly sessionService = inject(SessionLifecycleService);
  private readonly logger = inject(LogService);

  private _fpPromise: Promise<string> | null = null;

  async getVisitorId(): Promise<string> {
    const sessionId = this.sessionService.getSessionId();

    if (sessionId) {
      this.logger.info('[FingerprintService] Usando sessionId existente');
      return sessionId;
    }

    const fingerprintId = await this._getFingerprintId();
    this.logger.info('[FingerprintService] Usando fingerprintId resuelto');
    return fingerprintId;
  }

  private async _getFingerprintId(): Promise<string> {
    if (this._fpPromise) {
      return this._fpPromise;
    }

    this._fpPromise = this._loadFingerprint();

    return this._fpPromise;
  }

  private async _loadFingerprint(): Promise<string> {
    try {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      return result.visitorId;
    } catch (_error) {
      return this._generateFallbackId();
    }
  }

  private _generateFallbackId(): string {
    return `anonymous-${Date.now()}`;
  }
}
